import {
    Actuate,
    Administration,
    Bank,
    CorpayOne,
    Dashboard,
    Outlay,
    PowerBI,
    Salary,
    Settings,
    Support,
    Vat,
    Voucher,
} from '@/components/icons';
import NavMenuOutlay from '@/components/NavMenuOutlay.vue';
import Permission from '@/enums/Permission';
import { type NavItem } from '@/types';

export const mainNavItems: NavItem[] = [
    {
        title: 'menu.dashboards',
        group: 'dashboard',
        href: '',
        icon: Dashboard,
        customCheck: 'isNotClient',
        permissionLevel: Permission.DASHBOARD_VIEW,

        subItems: [
            {
                title: 'menu.employee_dashboard',
                href: route('v2.dashboard.index'),
                permissionLevel: Permission.DASHBOARD_ADMIN_VIEW,
            },
            {
                title: 'menu.customer_dashboard',
                href: route('v2.dashboard.customer.index'),
                permissionLevel: Permission.DASHBOARD_VIEW,
            },
        ],
    },
    {
        title: 'menu.dashboard',
        group: 'dashboard',
        href: route('v2.dashboard.customer.index'),
        icon: Dashboard,
        customCheck: 'isClient',
        permissionLevel: Permission.DASHBOARD_VIEW,
    },
    {
        title: 'menu.salary',
        group: 'salary',
        href: '',
        icon: Salary,
        customCheck: 'salary',

        subItems: [
            {
                title: 'menu.status',
                href: route('v2.salary.status.index'),
                permissionLevel: Permission.SALARY_STATUS_VIEW,
            },
            {
                title: 'menu.payrolls',
                href: route('v2.salary.payrolls.index'),
                permissionLevel: [Permission.SALARY_PAYSLIPS_VIEW, Permission.SALARY_PAYROLLS_VIEW],
            },
            {
                title: 'menu.employees-optionals',
                href: route('v2.salary.employees-optionals.index'),
                permissionLevel: Permission.SALARY_COMPANY_VIEW,
            },
            {
                title: 'menu.holiday-pay-obligations',
                href: route('v2.salary.holiday-pay-obligations.index'),
                permissionLevel: Permission.HOLIDAY_PAY_OBLIGATIONS_VIEW,
            },
            {
                title: 'menu.salary_setup',
                href: route('v2.salary.holidays.index'),
                permissionLevel: [Permission.HOLIDAYS_VIEW, Permission.WORK_CALENDARS_VIEW],
            },
            {
                title: 'menu.payroll_activity_log',
                href: route('v2.salary.log.index'),
                permissionLevel: Permission.SALARY_COMPANY_VIEW,
            },
        ],
    },
    {
        title: 'menu.voucher',
        group: 'voucher',
        href: route('v2.vouchers.index'),
        icon: Voucher,
        permissionLevel: [Permission.VOUCHERS_VIEW, Permission.VOUCHERS_OWN_VIEW],
    },
    {
        title: 'menu.bank',
        group: 'bank',
        href: route('v2.bank.index'),
        icon: Bank,
        permissionLevel: Permission.BANK_VIEW,
    },
    {
        title: 'menu.vat',
        group: 'vat',
        href: route('v2.vat.index'),
        icon: Vat,
        permissionLevel: Permission.VAT_VIEW,
    },
    {
        title: 'menu.power_bi',
        group: 'power-bi',
        href: '',
        icon: PowerBI,
        permissionLevel: [Permission.POWERBI_VIEW, Permission.POWERBI_SETUP_VIEW],
        subItems: [
            {
                title: 'menu.power_bi_dashboard',
                href: route('v2.powerbi.dashboard.index'),
                permissionLevel: Permission.POWERBI_VIEW,
            },
            {
                title: 'menu.power_bi_mapping',
                href: route('v2.powerbi.setup.index'),
                permissionLevel: Permission.POWERBI_SETUP_VIEW,
            },
        ],
    },
    {
        title: 'menu.administration',
        group: 'administration',
        href: '',
        icon: Administration,
        customCheck: 'isNotClient',
        permissionLevel: [
            Permission.COMPANIES_VIEW,
            Permission.POWERBI_SETUP_VIEW,
            Permission.USERS_VIEW,
            Permission.TRANSLATIONS_VIEW,
            Permission.SYSTEM_VIEW,
            Permission.ACTIVITIES_VIEW,
            Permission.HOLIDAYS_VIEW,
            Permission.ROLES_VIEW,
            Permission.WORK_CALENDARS_VIEW,
        ],
        subItems: [
            {
                title: 'menu.users',
                href: route('v2.users.index'),
                permissionLevel: Permission.USERS_VIEW,
            },
            {
                title: 'menu.customer_employees',
                href: route('v2.salary.employees.index'),
                permissionLevel: Permission.EMPLOYEES_VIEW,
            },
            {
                title: 'menu.task-templates',
                href: route('v2.task-templates.index'),
                permissionLevel: Permission.TASK_TEMPLATES_VIEW,
            },
            {
                title: 'menu.credit_cards',
                href: route('v2.credit-cards.index'),
                permissionLevel: Permission.CREDIT_CARDS_VIEW,
            },
            {
                title: 'menu.onboarding',
                href: route('v2.onboarding.index'),
                customCheck: 'isNotClient',
                permissionLevel: Permission.ONBOARDING_VIEW,
            },
        ],
    },
    {
        title: 'menu.administration',
        group: 'administration',
        href: '',
        icon: Administration,
        customCheck: 'isClient',
        permissionLevel: [Permission.EMPLOYEES_VIEW, Permission.CREDIT_CARDS_VIEW],
        subItems: [
            {
                title: 'menu.customer_employees',
                href: route('v2.salary.employees.index'),
                permissionLevel: Permission.EMPLOYEES_VIEW,
            },
            {
                title: 'menu.credit_cards',
                href: route('v2.credit-cards.index'),
                permissionLevel: Permission.CREDIT_CARDS_VIEW,
            },
        ],
    },
];

export const secondaryNavItems: NavItem[] = [
    {
        title: 'menu.outlay',
        group: 'outlay',
        href: route('outlay.login'),
        icon: Outlay,
        permissionLevel: Permission.OUTLAY_VIEW,
        customCheck: 'isNotClient',
        component: NavMenuOutlay,
    },
    {
        title: 'menu.outlay',
        group: 'outlay',
        href: route('outlay.login-with-user-id'),
        icon: Outlay,
        permissionLevel: Permission.OUTLAY_VIEW,
        customCheck: 'hasOutlay',
        component: NavMenuOutlay,
    },
    {
        title: 'menu.corpay_one',
        group: 'corpay',
        href: route('v2.corpay-one.redirect'),
        icon: CorpayOne,
        customCheck: 'hasCorpayOne',
        external: true,
    },
    {
        title: 'menu.actuate',
        group: 'actuate',
        href: route('v2.actuate.redirect'),
        icon: Actuate,
        permissionLevel: Permission.USERS_VIEW,
        external: true,
    },
    {
        title: 'menu.support',
        group: 'support',
        href: route('v2.support.redirect'),
        icon: Support,
        external: true,
    },
];

export const footerNavItems: NavItem[] = [
    {
        title: 'menu.settings',
        href: '',
        group: 'settings',
        icon: Settings,
        permissionLevel: Permission.USERS_VIEW,
        subItems: [
            {
                title: 'menu.companies',
                href: route('v2.companies.index'),
                permissionLevel: Permission.COMPANIES_VIEW,
            },
            {
                title: 'menu.employees',
                href: route('v2.user-companies.index'),
                permissionLevel: Permission.USERS_VIEW,
            },
            {
                title: 'menu.roles',
                href: route('v2.roles.index'),
                permissionLevel: Permission.ROLES_VIEW,
            },
            {
                title: 'menu.system',
                href: route('v2.vat-deadlines.index'),
                permissionLevel: Permission.SYSTEM_VIEW,
            },
        ],
    },
];
